<template>
    <div class="row plain-element">
        <div v-if="!isLoggedIn()" class="dashboard-cards">
            <NoPermissionComponent/>
        </div>
        <div v-if="getUsername()" class="dashboard" v-cloak>
            <div class="row row-cards">
                <div class="row text-start row-back">
                    <a href="/">
                        <span class="material-icons chevron-left">chevron_left</span> Back To Homepage
                    </a>
                </div>
                <div v-if="getEnergyEyeDashboards()" class="card card-description">
                    <div class="row plain-element">
                        <div class=" col col-12 col-sm-12 col-md-6 col-lg-6 plain-element">
                            <div class="row plain-element">
                                <div class=" col col-12 col-sm-12 col-md-4 col-lg-4 plain-element">
                                    <span class="section-header ">Service Sites</span>
                                </div>
                            </div>
                            <div class="row plain-element">
                                <div class=" col col-12 col-sm-12 col-md-8 col-lg-5 plain-element">
                                    <div v-for="(value, key) in getEnergyEyeDashboards().slice(0,12)"
                                         class="input-field  col col-12 col-sm-12 col-md-10 col-lg-10 col-form"
                                         :key="key" :value="value">
                                        <a @click="goToEnergyEyeDashboard(value.site_code)">
                                            <div class="card menu-card">
                                                <div class="row plain-element">
                                                    <div class=" col col-12 col-sm-10 col-md-12 col-lg-12 plain-element">
                                                        <h5><span
                                                                class="material-icons chevron-right">chevron_right</span>
                                                            {{ value.site_name }} <span class="font-grey">[{{ value.site_code }}]</span>
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div class=" col col-12 col-sm-12 col-md-8 col-lg-5 plain-element">
                                    <div v-for="(value, key) in getEnergyEyeDashboards().slice(12,24)"
                                         class="input-field  col col-12 col-sm-12 col-md-10 col-lg-10 col-form"
                                         :key="key" :value="value">
                                        <a @click="goToEnergyEyeDashboard(value.site_code)">
                                            <div class="card menu-card">
                                                <div class="row plain-element">
                                                    <div class=" col col-12 col-sm-10 col-md-12 col-lg-12 plain-element">
                                                        <h5><span
                                                                class="material-icons chevron-right">chevron_right</span>
                                                            {{ value.site_name }} <span class="font-grey">[{{ value.site_code }}]</span>
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div class=" col col-12 col-sm-12 col-md-8 col-lg-3 plain-element">
                                    <div v-for="(value, key) in getEnergyEyeDashboards().slice(24)"
                                         class="input-field  col col-12 col-sm-12 col-md-10 col-lg-10  col-form"
                                         :key="key" :value="value">
                                        <a @click="goToEnergyEyeDashboard(value.site_code)">
                                            <div class="card menu-card">
                                                <div class="row plain-element">
                                                    <div class=" col col-12 col-sm-10 col-md-12 col-lg-12 plain-element">
                                                        <h5><span
                                                                class="material-icons chevron-right">chevron_right</span>
                                                            {{ value.site_name }} <span class="font-grey">[{{ value.site_code }}]</span>
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class=" col col-12 col-sm-12 col-md-5 col-lg-5 plain-element">
                            <div class="row plain-element">
                                <div class=" col col-12 col-sm-12 col-md-10 col-lg-10 plain-element">
                                    <span class="section-header">My Recent Queries</span>
                                </div>
                            </div>
                            <div v-if="getUserEnergyEyeRecentQueries()" class="row plain-element">
                              <div class=" col col-12 col-sm-12 col-md-12 col-lg-12 plain-element">
                                <p class="w-100"></p>
                                    <table>
                                      <thead>
                                        <tr>
                                          <th class="text-start">Site</th>
                                          <th class="text-start">Interval</th>
                                          <th class="text-start">Query</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="(element, index) in keywordFilteredQueryList" :key="index" @click="goToEnergyEyeQueryDashboard(element)">
                                          <td class="text-start" style="font-size:14px; padding: 16px;">{{element.site_code}}</td>
                                          <td class="text-start" style="font-size:12px;">{{element.interval}}</td>
                                          <td class="text-start" style="font-size:12px;">
                                          {{ element.start_date }} - {{element.end_date}}
                                          <span class="font-blue" style="margin: 0px 12px">{{ transformMeterString(element.primary_meters) }}</span>
                                          <span v-if="element.secondary_meter" class="font-green" style="margin: 0px 12px">{{ element.secondary_meter }}</span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="activatedTab === 'recent' && getUserEnergyEyeRecentQueries()"
                         class="card card-description">
                        <p class="w-100"></p>

                        <p class="w-100"></p>
                        <div id="parent">
                            <div id="child">
                                <table id="searchTable">
                                    <thead>
                                    <tr>
                                        <th class="text-start">Company</th>
                                        <th class="text-start">Site Code</th>
                                        <th class="text-start">Interval</th>
                                        <th class="text-start">Date Range</th>
                                        <th class="text-start th-description">Primary Meters</th>
                                        <th class="text-start th-description">Secondary Meter</th>
                                        <th class="text-start">Query Date & Time
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(element, index) in keywordFilteredQueryList" :key="index"
                                        @click="goToEnergyEyeQueryDashboard(element)">
                                        <td class="text-start field-number" style="width: 5%;">
                                            <img :src="'https://saperapublicstorage.blob.core.windows.net/media/logos/' + element.company_name + '.png'"
                                                 alt="Logo" style="height: 30px;"/>
                                        </td>
                                        <td class="text-start field-number" style="width: 5%; font-size:14px;">
                                            {{element.site_code}}
                                        </td>
                                        <td class="text-start field-number" style="width: 5%; font-size:14px;">
                                            {{element.interval}}
                                        </td>
                                        <td class="text-start field-number" style="width: 10%; font-size:14px;">{{
                                            element.start_date }} - {{element.end_date}}
                                        </td>
                                        <td class="text-start" style="font-size:14px;">{{
                                            transformMeterString(element.primary_meters) }}
                                        </td>
                                        <td class="text-start" style="font-size:14px;">{{ element.secondary_meter }}
                                        </td>
                                        <td class="text-start" style="font-size:14px;">{{element.query_date}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import NoPermissionComponent from "@/components/NoPermissionComponent.vue";


export default {
  name: "EnergyEyeSelectView",
  components: {
    NoPermissionComponent,

  },
  props: {

  },
  data() {
    return {
      site: "",
      search: "",
      querySearch: "",
      activatedTab: "sites",
    }
  },

  methods: {
    ...mapGetters(["getUsername", "isLoggedIn", "getServiceSitesAndSeu", "getLoader",
                    "getFormError","getEnergyEyeDashboards", "getSiteNames", "getUserEnergyEyeRecentQueries"]),
    ...mapActions(["performSetFormError", "fetchEnergyEyeDashboards", "fetchUserEnergyEyeRecentQueries", "fetchSites"]),

    goToEnergyEyeDashboard(site_code) {
      window.open(`/energy-eye/${site_code}`, '_blank');
    },
    goToEnergyEyeQueryDashboard(object) {
      const siteCode = encodeURIComponent(object.site_code);
      const interval = encodeURIComponent(object.interval);
      const startDate = encodeURIComponent(object.start_date);
      const endDate = encodeURIComponent(object.end_date);
      const primaryMeters = encodeURIComponent(object.primary_meters);

      const secondaryMeter = object.secondary_meter
        ? encodeURIComponent(object.secondary_meter)
        : encodeURIComponent("na");

      const url = `/energy-eye-query/${siteCode}/${interval}/${startDate}/${endDate}/${primaryMeters}/${secondaryMeter}`;
      window.open(url, '_blank');
    },
    activateTab(activatedTab) {
        this.activatedTab = activatedTab
    },
    transformMeterString(input) {
        // Remove the brackets and single quotes, and then split by comma
        const items = input.replace(/[[\]']/g, '').split(',');

        // Trim any leading or trailing whitespace from each item
        const trimmedItems = items.map(item => item.trim());

        // Join the items with " | "
        return trimmedItems.join(' ---|--- ');
    }
  },
  computed: {
    keywordFilteredList() {
      return this.getEnergyEyeDashboards()
      .filter(element => {
        return element.company_name.toLowerCase().includes(this.search.toLowerCase()) ||
               element.site_code.toLowerCase().includes(this.search.toLowerCase()) ||
               element.site_name.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    keywordFilteredQueryList() {
      return this.getUserEnergyEyeRecentQueries()
      .filter(element => {
        return element.company_name.toLowerCase().includes(this.querySearch.toLowerCase()) ||
               element.site_code.toLowerCase().includes(this.querySearch.toLowerCase()) ||
               element.primary_meters.toLowerCase().includes(this.querySearch.toLowerCase()) ||
               element.secondary_meter.toLowerCase().includes(this.querySearch.toLowerCase())
      })
    }
  },

  created() {
    document.title = "Energy Eye";
    this.performSetFormError(null)
    this.fetchEnergyEyeDashboards();
    this.fetchUserEnergyEyeRecentQueries({"user": this.getUsername()})
    window.scrollTo(0,0);
  }
}


</script>
<style scoped>
.expanded {
  cursor: pointer;
}
.expanded:hover {
  text-decoration: underline;
}
</style>